import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortCommonTableComponent } from './port-common-table.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { PortCommonTableRoutingModule } from './port-common-table-routing.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';



@NgModule({
  declarations: [
    PortCommonTableComponent
  ],
  imports: [
    CommonModule,
    CustomDatePickerModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    CustomTimpickerModule,
    CustomInputModule,
    MatSortModule,
    PortCommonTableRoutingModule,
    PcMultiSelectFilterModule
  ],
  exports: [
    PortCommonTableComponent
  ]
})
export class PortCommonTableModule { }
